// Method found at https://davidwalsh.name/query-string-javascript
export default (queryParams, name) => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    const results = regex.exec(queryParams);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
